import { SmartenitPlugin } from '../smartenit-plugin';
import { TemperatureConverterService } from '../../common/temperature-converter.service';
import { IWebSocketDeviceMessage } from '../../websockets/websocket-device-message.interface';
import { INumericValue } from '../../interfaces/numeric-value.interface';
import { ITextValue } from '../../interfaces/text-value.interface';
import { Observable } from 'rxjs/Observable';

export class TemperatureMeasurementServerPlugin extends SmartenitPlugin
  implements INumericValue, ITextValue {
  private static readonly INVALID_VALUE = 0x8000;

  public onInit() {
    this.getCache().subscribe((state) => {
      if (state !== undefined) {
        this.state = state;
        this._onUpdate.next({ state });
      }
    });
  }

  public getReportableAttrs() {
    return ['MeasuredValue', 'Tolerance'];
  }

  public getStatus(context?: string, subscribe?: boolean): any {
    context = 'MeasuredValue';
    this.getAttributeWithSubscribeOption(
      this.componentId,
      this.processorName,
      context,
      null,
      false
    );
  }

  public setValue(value: number, attribute?: string, subscribe?: boolean): any {
    // Do nothing becase values are read only
    if (subscribe) {
      return Observable.of(true);
    }
    return true;
  }

  public getValue(attribute?: string): number {
    const response: number = Number(this.state);
    return response;
  }

  public getConditionAttribute(): string {
    return 'MeasuredValue';
  }

  public getEffectAttribute(): string | null {
    return null;
  }

  public getEffectMethod(context?: any): string | null {
    return null;
  }

  public getConditionOptions(): any {
    return null;
  }

  public getEffectOptions(): any {
    return null;
  }

  public getUnit(attribute?: string): string {
    return this.temperatureConverterService.getUnit();
  }

  public getTextValue(context?: string) {
    let temperature = '';
    if (this.state) {
      if (this.state !== TemperatureMeasurementServerPlugin.INVALID_VALUE) {
        temperature = Math.floor(
          this.temperatureConverterService.convert(
            this.getValue(),
            TemperatureConverterService.DEFAULT_TEMPERATURE
          )
        ).toString();
      }
    } else {
      temperature = '--';
    }

    return temperature
      ? `${temperature.toString()}${this.getUnit()}`
      : temperature;
  }

  public formatValue(value: string): string {
    if (value != null && !isNaN(Number(value))) {
      const temperature = Math.floor(
        this.temperatureConverterService.convert(
          Number(value),
          TemperatureConverterService.DEFAULT_TEMPERATURE
        )
      );
      return `${temperature.toString()}`;
    } else {
      return value;
    }
  }

  public getStatusPayload(): any {
    return ['MeasuredValue'];
  }

  public processMessage(
    message: IWebSocketDeviceMessage,
    timestamp?: number
  ): any {
    const response = (message && message.data && message.data.response) || {};
    const attributeOrMethod = message && message.attributeOrMethod;
    const value = response.value;

    if (attributeOrMethod === 'MeasuredValue') {
      let measuredValue;
      if (value === TemperatureMeasurementServerPlugin.INVALID_VALUE) {
        measuredValue = value;
        this.state = measuredValue;
      } else {
        measuredValue = parseInt(value) / 100;
        this.state = Math.round(measuredValue);
      }
      this._onUpdate.next({ state: measuredValue });
    }

    return this.state;
  }

  public getRawValue(
    value: number,
    attribute?: string,
    method?: string
  ): number {
    if (!attribute || attribute === 'MeasuredValue') {
      return this.pluginUtilsService.getValueByMultiplying(value, 100);
    } else {
      return value;
    }
  }

  public getProcessedValue(value: any, attribute?: string, method?: string) {
    if (!attribute || attribute === 'MeasuredValue') {
      return this.pluginUtilsService.getValueByDividing(value, 100);
    } else {
      return value;
    }
  }
}
